import type { IEndpoint } from '../../types';

import { casinoConfigParser } from './parsers';
import { CasinoConfigType, ICasinoConfig } from './types';

export const casinoConfigEndpoint: IEndpoint<CasinoConfigType, undefined> = {
  url: '/api/config/casino',
  parser: (rawResponse): CasinoConfigType => casinoConfigParser(rawResponse as ICasinoConfig),
  format: 'json',
};
